
import '../../imports/fontAwesome.js';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { ToggleButton } from 'vue-js-toggle-button';
import { VTooltip, VPopover, VClosePopover } from 'v-tooltip';

export default {
	name: 'SapphireToggle',
	props: {
		label: {
			type: String,
			default: '',
			required: false,
		},
		value: {
			type: Boolean | String | Number,
			required: true
		},
		toggleClasses: {
			type: String | Object,
			required: false
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		toggleSwitchClasses: {
			type: String | Object,
			required: false
		},
		isDirty: {
			type: Boolean,
			required: false
		},
		useDirtyIcon: {
			type: Boolean,
			default: false
		},
		showInFront: {
			type: Boolean,
			default: true
		}
	},
	computed:{
		toggleClass() {
			if(this.label === '') {
				if(this.useDirtyIcon && this.isDirty) {
					return 'col-xs-12'
				} else {
					return 'col-xs-12 col-md-12';
				}
			} else {
				if(this.useDirtyIcon && this.isDirty) {
					return 'col-xs-4 col-sm-4 col-md-4';
				} else {
					if(this.showInFront) {
						return 'col-xs-4 col-md-4';
					} else {
						return 'col-xs-4 col-md-4';
					}
				}
			}
		},
		labelClass() {
			if(this.label === '') {
				return '';
			} else {
				if(this.useDirtyIcon && this.isDirty) {
					return 'col-xs-8 col-sm-8 col-md-8';
				} else {
					return 'col-xs-8 col-sm-8';
				}
			}
		},
		toggleValue: {
			get() {
				if(typeof this.value === 'string') {
					if(this.value.length > 1) {
						return this.value.toUpperCase() === 'YES';
					}
					if(this.value.length === 1) {
						return this.value.toUpperCase() === 'Y';
					}
					if(this.value.length === 0) {
						return false;
					}
				}
				if(typeof this.value === 'number') {
					return this.value === 1;
				}
				if(typeof this.value === 'boolean') {
					return this.value;
				}
			},
			set(v) {
				if(typeof this.value === 'string') {
					if(this.value.length > 1) {
						v ?	this.$emit('input', 'YES') : this.$emit('input', 'NO');
					}
					if(this.value.length === 1) {
						v ? this.$emit('input', 'Y') : this.$emit('input', 'N');
					}
					if(this.value.length === 0) {
						let val = v ? 'Y' : 'N';
						this.$emit('input', val);
					}
				}
				if(typeof this.value === 'number') {
					v ? this.$emit('input', 1) : this.$emit('input', 0);
				}
				if(typeof this.value === 'boolean') {
					this.$emit("input", v);
				}
			}
		}
	},
	directives: {
		'tooltip': VTooltip,
		'close-popover': VClosePopover,
		'v-popover': VPopover
	},
	components: {
		FontAwesomeIcon,
		'toggle-button': ToggleButton
	},
	methods: {
		changeToggle() {
			if(!this.disabled) {
				this.toggleValue = !this.toggleValue;
			}
		}
	}
}
